import { useState, useContext, useEffect } from "react";

import LocationContext from "@context/location/locationContext";
import { getCustomExtraPath } from "@pages/Dashboard/RevenueDashBoard/TotalSales/helper";
import CustomDataTable from "@shared-ui-components/CustomDataTable";
import Colors from "@src/constants/Colors";
import { getApiResponse } from "@src/utils/service";
import { SORTKEYMAP } from "@src/constants/DataTable";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import { message } from "@src/constants";
import { columns, refineData } from "./helper";
import { Product } from "../ProductMixRevenueBreakdown/type";
import { StyledBox, StyledRootBox, StyledTypography } from "./style";

const ProductMixBreakdownAllItems = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [rowData, setRowsData] = useState<Product[]>([]);

  const [pageNumber, setPageNumber] = useState(0);
  const [category, setCategory] = useState("");
  const [sortBy, setSortBy] = useState({
    tableName: "cost",
    label: "Cost",
    order: "desc",
  });
  const [{ locationState }] = useContext(LocationContext);

  const { property, store, revenueCenter, date } = locationState;

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);
  const filters = {
    property,
    store,
    rvc: revenueCenter,
    sortBy: "Cost",
    date,
  };

  const filter = getCustomExtraPath(filters);

  const url = `product-mix-details${filter}&filter_by=${category.toLowerCase()}&sort_by=${
    sortBy.tableName
  }&sort_order=${sortBy.order === "desc" ? "desc" : "asc"}&page=${
    pageNumber + 1
  }`;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage - 1);
  };

  const localProductFilter = localStorage.getItem("ProductFilter");

  const sortHandler = (sortkey: string) => {
    const sortKeyObject = SORTKEYMAP.find(
      (el) => el.tableName === sortkey.toLowerCase()
    );
    setSortBy((prev) => {
      if (sortKeyObject) {
        return {
          tableName: sortKeyObject.label,
          label: sortkey,
          order: prev.order === "desc" ? "asc" : "desc",
        };
      }
      return prev;
    });
  };

  useEffect(() => {
    setPageNumber(0);
    if (localProductFilter !== null) {
      const localFilters = JSON.parse(localProductFilter);
      setCategory(localFilters.category);
    }
  }, [property, store, revenueCenter, date, localProductFilter]);

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await getApiResponse(url);
        setIsLoading(false);
        if (data !== null) {
          const refinedData = refineData(data);
          setRowsData(refinedData);
        } else {
          showErrorToastSetState({
            errorMessage: error || "",
            errorTitle: message.ERROR_MESSAGE_DASHBOARD,
            open: true,
          });
        }
      } catch (err) {
        showErrorToastSetState({
          errorMessage: "",
          errorTitle: message.ERROR_MESSAGE_DASHBOARD,
          open: true,
        });
        setIsLoading(false);
      }
    };
    if (category.length > 0) {
      getData();
    } else {
      setIsLoading(false);
    }
  }, [url, category]);

  return (
    <StyledRootBox>
      <StyledBox>
        <StyledTypography color={Colors.primary}>
          {`${category} with Margin`}
        </StyledTypography>
      </StyledBox>
      <CustomDataTable
        sortHandler={sortHandler}
        rowData={refineData(rowData)}
        page={pageNumber}
        showPagination
        sortBy={sortBy}
        handleNavigate={() => null}
        handlePageChange={handleChangePage}
        isLoading={isLoading}
        dyColumns={columns}
      />
    </StyledRootBox>
  );
};

export default ProductMixBreakdownAllItems;
